import { GridDataRow, simpleHeader } from "@homebound/beam";
import { ProjectItem } from "src/generated/graphqlTypes";
import { ProjectItemStore, SpecsAndSelectionsRow } from "src/routes/projects/models/ProjectItemStore";
import { DeepPartial } from "src/utils";

export function createSpecsAndSelectionRows(
  piStore: ProjectItemStore,
  showPlanSource: boolean,
): GridDataRow<SpecsAndSelectionsRow>[] {
  return [
    { kind: "totals" as const, id: "totals", data: piStore },
    simpleHeader,
    ...piStore.groupedBy.map((group) => ({
      kind: "group" as const,
      id: group.id,
      data: group,
      children: group.children.map((pi) => ({
        kind: "projectItem" as const,
        id: pi.id,
        data: pi,
        children: showPlanSource
          ? [pi.fragment.itemTemplateItem, ...pi.fragment.modifyingTemplateItems]
              .compact()
              .map((li, i) => ({ kind: "lineItem" as const, id: `${pi.id}-${li.id}-${i}`, data: li }))
          : [],
      })),
      // sortValue defined for each ObservableProjectItemGroup in ProjectItemStore
      sortValue: group.sortValue,
    })),
  ];
}

export function isUnallocatedCost(projectItem: DeepPartial<ProjectItem>): boolean {
  return !projectItem.task?.id && projectItem.totalCostInCents !== 0;
}

export function getIsLocationRequired(projectType: string): boolean {
  return !["Community", "Subdivision", "Lot"].includes(projectType);
}
